import { useContext, useEffect } from "react";
import { NavContext } from "../contexts/NavContextProvider";
import { updateDocumentTitle } from "..";
import SubPageTitle from "../SubPageTitle";
import { MessageBar, MessageBarBody, MessageBarTitle, MessageBarActions, Button } from "@fluentui/react-components";
import { DataTrendingFilled } from "@fluentui/react-icons";

export default function TelemetryPage() {
    const { navData, setNavData } = useContext(NavContext);

    useEffect(
        () => {
            updateDocumentTitle( "Telemetry | Overview" );
            navData.sidebarSelectedNavValue = "telemetry";
            navData.subPageNavValue = null;
            setNavData({...navData});
        },
        []
    );

    return (
        <>
            <SubPageTitle icon={<DataTrendingFilled />} title="Telemetry" subTitle="Overview" />

            <MessageBar intent="warning" style={{ marginBottom: "1rem" }}>
                <MessageBarBody>
                    <MessageBarTitle>Telemetry Disabled</MessageBarTitle>
                    Telemetry is currently disabled for the active product. In order to use these features, you must enable telemetry first.
                </MessageBarBody>
                <MessageBarActions>
                    <Button size="small">Enable</Button>
                </MessageBarActions>
            </MessageBar>
        </>
    );
}